import { notifyInfo, notifySuccess, notifyWarning } from './notify.js';

// A toast cannot survive a page load, so the sender puts a key in the URL
// (?hinweis=…) and the freshly loaded page turns it back into a notification.
const MESSAGES = {
  angemeldet: { notify: notifySuccess, text: 'Erfolgreich angemeldet. Willkommen zurück!' },
  abgemeldet: { notify: notifySuccess, text: 'Sie wurden erfolgreich abgemeldet.' },
  'sitzung-abgelaufen': {
    notify: notifyWarning,
    text: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.'
  },
  'profilbild-gespeichert': { notify: notifySuccess, text: 'Ihr Profilbild wurde gespeichert.' },
  'profilbild-entfernt': { notify: notifySuccess, text: 'Ihr Profilbild wurde entfernt.' },
  'passkey-registriert': { notify: notifySuccess, text: 'Passkey wurde registriert.' },
  'passkey-entfernt': { notify: notifySuccess, text: 'Passkey wurde entfernt.' },
  'passkey-umbenannt': { notify: notifySuccess, text: 'Passkey wurde umbenannt.' },
  'passkey-zurueckgesetzt': { notify: notifySuccess, text: 'Passkeys wurden zurückgesetzt.' },
  'codes-erneuert': { notify: notifySuccess, text: 'Wiederherstellungscodes wurden erneuert.' },
  'passkey-erforderlich': {
    notify: notifyWarning,
    text: 'Ihre Rolle verlangt einen Passkey. Bitte richten Sie jetzt einen ein.'
  },
  'filiale-erstellt': { notify: notifySuccess, text: 'Filiale wurde erstellt.' },
  'filiale-aktualisiert': { notify: notifySuccess, text: 'Filiale wurde aktualisiert.' },
  'filiale-geloescht': { notify: notifySuccess, text: 'Filiale wurde gelöscht.' },
  'ansprechperson-erstellt': { notify: notifySuccess, text: 'Ansprechperson wurde erstellt.' },
  'ansprechperson-aktualisiert': {
    notify: notifySuccess,
    text: 'Ansprechperson wurde aktualisiert.'
  },
  'ansprechperson-geloescht': { notify: notifySuccess, text: 'Ansprechperson wurde gelöscht.' },
  'dokument-hochgeladen': { notify: notifySuccess, text: 'Dokument wurde hochgeladen.' },
  'dokument-aktualisiert': { notify: notifySuccess, text: 'Dokument wurde aktualisiert.' },
  'dokument-geloescht': { notify: notifySuccess, text: 'Dokument wurde gelöscht.' },
  'kunde-erstellt': { notify: notifySuccess, text: 'Kunde wurde erstellt.' },
  'kunde-aktualisiert': { notify: notifySuccess, text: 'Kunde wurde aktualisiert.' },
  'kunde-geloescht': { notify: notifySuccess, text: 'Kunde wurde gelöscht.' },
  'kunde-status-geaendert': { notify: notifySuccess, text: 'Status wurde geändert.' },
  'konzern-erstellt': { notify: notifySuccess, text: 'Konzern wurde erstellt.' },
  'konzern-aktualisiert': { notify: notifySuccess, text: 'Konzern wurde aktualisiert.' },
  'job-erstellt': { notify: notifySuccess, text: 'Job wurde erstellt.' },
  'job-aktualisiert': { notify: notifySuccess, text: 'Job wurde aktualisiert.' },
  'job-geloescht': { notify: notifySuccess, text: 'Job wurde gelöscht.' },
  'job-status-geaendert': { notify: notifySuccess, text: 'Status wurde geändert.' },
  'liste-erstellt': { notify: notifySuccess, text: 'Liste wurde erstellt.' },
  'liste-aktualisiert': { notify: notifySuccess, text: 'Liste wurde aktualisiert.' },
  'liste-geloescht': { notify: notifySuccess, text: 'Liste wurde gelöscht.' },
  'kandidat-erstellt': { notify: notifySuccess, text: 'Kandidat wurde erfasst.' },
  'kandidat-aktualisiert': { notify: notifySuccess, text: 'Kandidat wurde aktualisiert.' },
  'kandidat-geloescht': { notify: notifySuccess, text: 'Kandidat wurde gelöscht.' },
  'vorschlag-erstellt': { notify: notifySuccess, text: 'Kandidat wurde vorgeschlagen.' },
  'vorschlag-aktualisiert': { notify: notifySuccess, text: 'Status wurde geändert.' },
  'vorschlag-entfernt': { notify: notifySuccess, text: 'Vorschlag wurde entfernt.' },
  'termin-erfasst': { notify: notifySuccess, text: 'Termin wurde erfasst.' },
  'termin-aktualisiert': { notify: notifySuccess, text: 'Termin wurde aktualisiert.' },
  'termin-entfernt': { notify: notifySuccess, text: 'Termin wurde entfernt.' },
  'aufgabe-erstellt': { notify: notifySuccess, text: 'Aufgabe wurde erstellt.' },
  'aufgabe-aktualisiert': { notify: notifySuccess, text: 'Aufgabe wurde aktualisiert.' },
  'aufgabe-erledigt': { notify: notifySuccess, text: 'Aufgabe wurde erledigt.' },
  'verlauf-erstellt': { notify: notifySuccess, text: 'Notiz wurde erfasst.' },
  'verlauf-aktualisiert': { notify: notifySuccess, text: 'Eintrag wurde aktualisiert.' },
  'verlauf-geloescht': { notify: notifySuccess, text: 'Eintrag wurde gelöscht.' },
  'stammdaten-erstellt': { notify: notifySuccess, text: 'Eintrag wurde erstellt.' },
  'stammdaten-aktualisiert': { notify: notifySuccess, text: 'Eintrag wurde aktualisiert.' },
  'stammdaten-geloescht': { notify: notifySuccess, text: 'Eintrag wurde gelöscht.' },
  'benutzer-erstellt': { notify: notifySuccess, text: 'Benutzer wurde erstellt.' },
  'benutzer-aktualisiert': { notify: notifySuccess, text: 'Benutzer wurde aktualisiert.' },
  'benutzer-aktiviert': { notify: notifySuccess, text: 'Benutzer wurde wieder aktiviert.' },
  'benutzer-deaktiviert': { notify: notifySuccess, text: 'Benutzer wurde deaktiviert.' },
  'benutzer-geloescht': { notify: notifySuccess, text: 'Benutzer wurde endgültig gelöscht.' },
  'konto-deaktiviert': {
    notify: notifyWarning,
    text: 'Ihr Konto wurde deaktiviert. Bitte wenden Sie sich an einen Administrator.'
  },
  'anmeldung-erforderlich': {
    notify: notifyInfo,
    text: 'Bitte melden Sie sich an, um fortzufahren.'
  }
};

export const FLASH_PARAM = 'hinweis';

// Builds a URL that shows `key` as a notification once the target page loads.
//
// Appends rather than assuming the path carries no query of its own: a caller
// that reloads the current page keeps its filters by passing them in, and a
// hardcoded '?' would produce '?abgesagte=1?hinweis=...' and lose both.
export function withFlash(path, key) {
  const trenner = path.includes('?') ? '&' : '?';
  return `${path}${trenner}${FLASH_PARAM}=${key}`;
}

export function initFlash() {
  const params = new window.URLSearchParams(window.location.search);
  const flash = MESSAGES[params.get(FLASH_PARAM)];
  if (!flash) return;

  flash.notify(flash.text);

  // Drop the parameter again so a reload does not repeat the notification.
  params.delete(FLASH_PARAM);
  const query = params.toString();
  window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : ''));
}
